import { defineComponent, reactive, ref, watch } from "vue";
import { VisaPageReq } from "@/views/contract/visa/visa.interface";
import { VisaService } from "@/views/contract/visa/visa.service";
import { columns } from "./visa-import-select.constant";

export default defineComponent({
  isGlobal: true,
  name: "VisaImportSelect",
  props: {
    projectId: {
      type: String,
      default: "",
    },
    needProjectId: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["change"],
  setup(props, { emit }) {
    const visible = ref(false);
    const selectedKeys = ref<string[]>([]);
    const selectedRows = ref<any[]>([]);
    const queryRef = reactive(new VisaPageReq()) as any;
    
    // 默认只查询审批通过的
    queryRef.flowStatus = "pass";

    const { data: dataSource, loading, run, refresh, pagination } = VisaService.usePageApiForWorkSetUpImport();

    const showModal = () => {
      if (props.needProjectId && !props.projectId) {
        return;
      }
      visible.value = true;
      search();
    };

    const closeModal = () => {
      visible.value = false;
    };

    const ok = () => {
      if (selectedRows.value.length) {
        emit("change", selectedRows.value);
      }
      closeModal();
    };

    const search = async () => {
      selectedKeys.value = [];
      selectedRows.value = [];
      queryRef.current = 1;
      queryRef.projectId = props.projectId;
      await run(queryRef);
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };

    const onSelectionChange = (keys: string[], rows: any[]) => {
      selectedKeys.value = keys;
      selectedRows.value = rows;
    };

    watch(
      () => props.projectId,
      async () => {
        if (props.needProjectId && !props.projectId) {
          return;
        }
        if (visible.value) {
          await search();
        }
      },
      { immediate: true }
    );

    return {
      visible,
      showModal,
      closeModal,
      ok,
      selectedKeys,
      queryRef,
      dataSource,
      loading,
      columns,
      pagination,
      search,
      onTableChange,
      onSelectionChange,
    };
  },
});
